<div
  animate.enter="animate-down"
  animate.leave="animate-up"
  class="w-full h-screen rounded-xl flex flex-col items-center justify-center relative"
>
  <div class="-top-4 -left-6 absolute"></div>
  <img src="assets/images/emblem.png" class="w-16 md:w-20" alt="" />
  <span class="text-black text-2xl font-bold mt-5 mb-2">
    Create Your
    <span class="text-primary-600">Meeting</span>
    Space
  </span>
  <p class="text-gray-600">
    Enter your credentials to start connecting and collaborating securely.
  </p>
  <div class="w-full mt-3">
    <form
      (ngSubmit)="register(form.value)"
      [formGroup]="form"
      autocomplete="off"
      novalidate
    >
      <div class="flex flex-col md:flex-row gap-4">
        <!-- First Name -->
        <mat-form-field appearance="outline" class="w-full md:w-1/2 my-2">
          <mat-label>{{
            ("First Name" | concat | translate) || "First Name"
          }}</mat-label>
          <input type="text" matInput formControlName="firstName" />
          <mat-icon matIconPrefix>person</mat-icon>
          @if (
            !form.get("firstName")?.valid && form.get("firstName")?.touched
          ) {
            <mat-error>
              {{ "Field is required" | concat | translate }}
            </mat-error>
          }
        </mat-form-field>

        <!-- Last Name -->
        <mat-form-field appearance="outline" class="w-full md:w-1/2 my-2">
          <mat-label>{{
            ("Last Name" | concat | translate) || "Last Name"
          }}</mat-label>
          <input type="text" matInput formControlName="lastName" />
          <mat-icon matIconPrefix>person</mat-icon>
          @if (!form.get("lastName")?.valid && form.get("lastName")?.touched) {
            <mat-error>
              {{ "Field is required" | concat | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="my-2">
        <mat-label>{{
          ("Phone Number" | concat | translate) || "Phone Number"
        }}</mat-label>
        <input type="text" matInput formControlName="phoneNumber" />
        <mat-icon matIconPrefix>phone</mat-icon>
        <mat-error>
          @if (form.get("phoneNumber")?.hasError("required")) {
            <span>{{ "Field is required" | concat | translate }}</span>
          } @else if (form.get("phoneNumber")?.hasError("pattern")) {
            <span>{{
              "Please enter a valid phone number" | concat | translate
            }}</span>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="my-2">
        <mat-label>{{
          ("Email Address" | concat | translate) || "Email Address"
        }}</mat-label>
        <input type="email" matInput formControlName="email" />
        <mat-icon matIconPrefix>email</mat-icon>
        <mat-error>
          @if (form.get("email")?.hasError("required")) {
            <span>
              {{ "Field is required" | concat | translate }}
            </span>
          }@else if (form.get("email")?.hasError("pattern")) {
            <span>
              {{ "Enter valid email" | concat | translate }}
            </span>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="my-2">
        <mat-label>{{
          ("Password" | concat | translate) || "Password"
        }}</mat-label>
        <input
          [type]="hide ? 'password' : 'text'"
          matInput
          formControlName="password"
        />
        <mat-icon matIconPrefix>lock</mat-icon>
        <button
          type="button"
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon class="material-icons-outlined"
            >{{ hide ? "visibility_off" : "visibility" }}
          </mat-icon>
        </button>
        <mat-error>
          @if (!form.get("password")?.valid && form.get("password")?.touched) {
            <span>
              {{ "Field is required" | concat | translate }}
            </span>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="my-2">
        <mat-label>{{
          ("Confirm Password" | concat | translate) || "Confirm Password"
        }}</mat-label>
        <input
          [type]="hide ? 'password' : 'text'"
          matInput
          formControlName="confirmPassword"
        />
        <mat-icon matIconPrefix>lock</mat-icon>
        <button
          type="button"
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon class="material-icons-outlined"
            >{{ hide ? "visibility_off" : "visibility" }}
          </mat-icon>
        </button>
        <mat-error>
          @if (
            !form.get("confirmPassword")?.valid &&
            form.get("confirmPassword")?.touched
          ) {
            <span>
              {{ "Field is required" | concat | translate }}
            </span>
          }
        </mat-error>
      </mat-form-field>

      <div class="w-full mb-3">
        <button
          [disabled]="!form.valid || loading"
          class="w-full"
          mat-raised-button
          color="primary"
        >
          {{ "Register" | concat | translate }}
        </button>
      </div>
    </form>
    <div class="w-full mt-4 text-center">
      <p class="text-sm md:text-md text-gray-dark">
        {{ "Do you have an account" | concat | translate }}?
        <a routerLink="/auth" class="text-primary font-bold">
          {{ "Login instead." | concat | translate }}
        </a>
      </p>
    </div>
  </div>
</div>
